import { EntityWithId } from "../baseEntities";
import { OrdenCampoAdicionalValorDTO } from "../camposAdicionales";

export const DOC_DNI_ID = 1;

export enum OrderPersonalInformationFields {
    Email = "mail",
    FirstName = "nombre",
    LastName = "apellido",
    Document = "documento",
    Cuit = "vchCuit",
    DocumentoTipo = "tinCodDocumentoTipo",
    AfipResponsableTipo = "tinCodAfipResponsableTipo",
    RazonSocial = "vchRazonSocial",
    AreaCode = "codigoArea",
    PhoneNumber = "telefono",
}

export enum OrderDeliveryAddressFields {
    Street = "calle",
    StreetNumber = "calleNro",
    FloorApartment = "pisoDpto",
    ZipCode = "codigoPostal",
    ProvinceCode = "codProvincia",
    LocalityDesc = "descLocalidad",
    IsPrivateNeighborhood = "barrioPrivado",
    NeighborhoodName = "nombreBarrio",
    Lot = "lote",
}

export interface OrderPersonalInformation {
    [OrderPersonalInformationFields.Email]: string;
    [OrderPersonalInformationFields.FirstName]?: string | null;
    [OrderPersonalInformationFields.LastName]?: string | null;
    [OrderPersonalInformationFields.Document]?: string | null;
    [OrderPersonalInformationFields.Cuit]?: string | null;
    [OrderPersonalInformationFields.DocumentoTipo]?: number | null;
    [OrderPersonalInformationFields.AfipResponsableTipo]?: number | null;
    [OrderPersonalInformationFields.RazonSocial]?: string | null;
    [OrderPersonalInformationFields.AreaCode]?: string | null;
    [OrderPersonalInformationFields.PhoneNumber]?: string | null;
    [OrderDeliveryAddressFields.Street]?: string | null;
    [OrderDeliveryAddressFields.StreetNumber]?: string | null;
    [OrderDeliveryAddressFields.FloorApartment]?: string | null;
    [OrderDeliveryAddressFields.ZipCode]?: string | null;
    [OrderDeliveryAddressFields.ProvinceCode]?: number | null;
    [OrderDeliveryAddressFields.LocalityDesc]?: string | null;
}

export interface OrderDeliveryAddress {
    [OrderDeliveryAddressFields.Street]: string | null;
    [OrderDeliveryAddressFields.StreetNumber]: string | null;
    [OrderDeliveryAddressFields.FloorApartment]: string | null;
    [OrderDeliveryAddressFields.ZipCode]: string;
    [OrderDeliveryAddressFields.ProvinceCode]: number | null;
    [OrderDeliveryAddressFields.LocalityDesc]: string | null;
    [OrderDeliveryAddressFields.IsPrivateNeighborhood]?: boolean | null;
    [OrderDeliveryAddressFields.NeighborhoodName]?: string | null;
    [OrderDeliveryAddressFields.Lot]?: string | null;
}

export enum OrderProductFields {
    ProductId = "idProducto",
    ProductVariantId = "idProductoVariante",
    Quantity = "cantidad",
}

export interface OrderProduct {
    [OrderProductFields.ProductId]: string;
    [OrderProductFields.ProductVariantId]: string;
    [OrderProductFields.Quantity]: number;
}

export enum OrderCheckoutFields {
    Subscribe = "usuarioSuscribeEmail",
    PersonalInformation = "datosPersonales",
    Products = "productos",
    DeliveryAddress = "domicilioEntrega",
    ShippingOptionId = "idEnvioOpcion",
    ShippingCost = "costoEnvio",
    CouponName = "nombreCupon",
    ShippingBranchId = "idEnvioProveedorSucursal",
    PaymentOptionId = "idPagoOpcion",
    PaymentData = "datosPago",
    CamposAdicionales = "camposAdicionales",
    PricingContext = "contextoPrecio",
}

export interface OrderPaymentData {
    codPagoProveedor: number;
    tarjetaNombreTitular?: string | null;
    tarjetaFechaVto?: string | null;
    codTarjetaTipo?: number | null;
    tarjetaNumero?: string | null;
    cbu?: string | null;
}

export interface OrderCheckoutUpdate {
    [OrderCheckoutFields.PersonalInformation]: OrderPersonalInformation;
    [OrderCheckoutFields.Products]: OrderProduct[];
    [OrderCheckoutFields.Subscribe]: boolean;
    [OrderCheckoutFields.DeliveryAddress]?: OrderDeliveryAddress;
    [OrderCheckoutFields.ShippingOptionId]?: string;
    [OrderCheckoutFields.ShippingCost]?: number | null;
    [OrderCheckoutFields.CouponName]?: string | null;
    [OrderCheckoutFields.ShippingBranchId]?: string | null;
    [OrderCheckoutFields.PaymentOptionId]?: string | null;
    [OrderCheckoutFields.PaymentData]?: OrderPaymentData | null;
    [OrderCheckoutFields.CamposAdicionales]?: OrdenCampoAdicionalValorDTO[] | null;
    [OrderCheckoutFields.PricingContext]?: string | null;
}

export enum OrderCheckoutFinishFields {
    Name = "nombreCupon",
}

export interface OrderCheckoutFinish extends OrderCheckoutUpdate {
    [OrderCheckoutFinishFields.Name]?: string;
    [OrderCheckoutFields.ShippingOptionId]?: string;
    [OrderCalculationRequestFields.ShippingCost]?: number | null;
}

export enum OrderCheckoutCreateFields {
    Email = "mail",
    ZipCode = "codigoPostal",
    IdShippingOption = "idEnvioOpcion",
    ShippingOptionPrice = "envioOpcionCosto",
    Products = "productos",
    ShippingBranchId = "idEnvioProveedorSucursal",
    PricingContext = "contextoPrecio",
}

export interface OrderCheckoutCreate {
    [OrderCheckoutCreateFields.Email]: string;
    [OrderCheckoutCreateFields.ZipCode]: string;
    [OrderCheckoutCreateFields.IdShippingOption]?: string | null;
    [OrderCheckoutCreateFields.ShippingOptionPrice]?: number | null;
    [OrderCheckoutCreateFields.Products]: OrderProduct[];
    [OrderCheckoutCreateFields.ShippingBranchId]?: string | null;
    [OrderCheckoutCreateFields.PricingContext]?: string | null;
}

export enum OrderShippingViewDTOFields {
    Cost = "costo",
    ProviderName = "nombreEnvioProveedor",
    Description = "descripcionEnvio",
    ProviderId = "idEnvioProveedor",
    RequestAddress = "solicitaDomicilioEnvio",
    OptionName = "descEnvioOpcion",
    ShippingTime = "tiempoEnvio",
    PackagingTime = "tiempoEmpaquetado",
    FormattedDescription = "descripcionEnvioFormateada",
    FixedCost = "costoFijo",
    IntegratedCost = "integracion",
    Branches = "sucursales",
}

export interface OrderShippingViewDTO extends EntityWithId<string> {
    [OrderShippingViewDTOFields.Cost]: number;
    [OrderShippingViewDTOFields.ProviderName]: string;
    [OrderShippingViewDTOFields.Description]: string;
    [OrderShippingViewDTOFields.ProviderId]: string;
    [OrderShippingViewDTOFields.RequestAddress]?: boolean;
    [OrderShippingViewDTOFields.OptionName]: string;
    [OrderShippingViewDTOFields.ShippingTime]: number;
    [OrderShippingViewDTOFields.PackagingTime]: number;
    [OrderShippingViewDTOFields.FormattedDescription]: string;
    [OrderShippingViewDTOFields.FixedCost]: boolean;
    [OrderShippingViewDTOFields.IntegratedCost]: boolean;
    [OrderShippingViewDTOFields.Branches]?: any[];
}

export interface CardTypeViewDTO {
    id: number;
    descripcion: string;
    sinCantDigitos: number;
}

export enum OrderPaymentOptionViewDTOFields {
    ProviderName = "nombrePagoProveedor",
    Description = "descripcionPago",
    OptionName = "descPagoOpcion",
    ProviderCode = "codPagoProveedor",
}

export interface OrderPaymentOptionViewDTO extends EntityWithId<string> {
    [OrderPaymentOptionViewDTOFields.ProviderName]: string;
    [OrderPaymentOptionViewDTOFields.Description]: string;
    [OrderPaymentOptionViewDTOFields.OptionName]: string;
    [OrderPaymentOptionViewDTOFields.ProviderCode]: number;
}

export enum OrderCalculationRequestFields {
    Products = "productos",
    CouponName = "nombreCupon",
    ShippingOptionId = "idEnvioOpcion",
    ShippingCost = "costoEnvio",
    PricingContext = "contextoPrecio",
}

export interface OrderCalculationRequest {
    [OrderCalculationRequestFields.Products]: OrderProduct[];
    [OrderCalculationRequestFields.CouponName]?: string | null;
    [OrderCalculationRequestFields.ShippingOptionId]?: string | null;
    [OrderCalculationRequestFields.ShippingCost]?: number | null;
    [OrderCalculationRequestFields.PricingContext]?: string | null;
}

export enum OrderCalculationViewFields {
    Subtotal = "subTotalOrden",
    ShippingCost = "costoEnvio",
    ShippingDiscount = "descuentoCostoEnvio",
    ProductsDiscount = "descuentoProductos",
    Total = "totalOrden",
}

export interface OrderCalculationView extends EntityWithId<string> {
    [OrderCalculationViewFields.Subtotal]: number;
    [OrderCalculationViewFields.ShippingCost]: number;
    [OrderCalculationViewFields.ShippingDiscount]: number;
    [OrderCalculationViewFields.ProductsDiscount]: number;
    [OrderCalculationViewFields.Total]: number;
}

export enum OrderFinishedInsufficientStockProductFields {
    ProductId = "idProducto",
    ProductVariantId = "idProductoVariante",
    ProductName = "nombreProducto",
    CurrentStock = "stockActual",
}

export interface OrderFinishedInsufficientStockProduct {
    [OrderFinishedInsufficientStockProductFields.ProductId]: string;
    [OrderFinishedInsufficientStockProductFields.ProductVariantId]: string;
    [OrderFinishedInsufficientStockProductFields.ProductName]: string;
    [OrderFinishedInsufficientStockProductFields.CurrentStock]: number;
}

export enum OrderFinishedFields {
    OrderNumber = "codigo",
    OrderFinishedInsufficientStockProductList = "listaProductosConStockInsuficiente",
    MercadoPagoPreferenceId = "mercadoPagoPreferenceId",
    MercadoPagoRedirectUrl = "mercadoPagoRedirectUrl",
}

export interface OrderFinished {
    [OrderFinishedFields.OrderNumber]: string;
    [OrderFinishedFields.OrderFinishedInsufficientStockProductList]?: OrderFinishedInsufficientStockProduct[];
    [OrderFinishedFields.MercadoPagoPreferenceId]?: string | null;
    [OrderFinishedFields.MercadoPagoRedirectUrl]?: string | null;
}
